import { nullSafeGetOrElse } from './DataAccessUtils';
import { FILTER_FIELD_TYPE, FILTER_VALUE_TYPE } from './DataConstants';
import {
	ALL_EPSL_CONDITIONS,
	ALL_EPSL_DISPOSITION_PLANS,
	EPSL_CONDITION_DISPLAY_NAMES,
	EPSL_DISPOSITION_PLAN_DISPLAY_NAMES,
} from './stockLocationUtils';
import posthog from 'posthog-js';

export const getPOLineItemUnitCostValue = (record, type) => {
	const quantity = nullSafeGetOrElse(`${type}Quantity`, record, 1);
	const receivedQuantity = nullSafeGetOrElse(`${type}ReceivedQuantity`, record, 1);
	const qtyToConsider = receivedQuantity > quantity ? receivedQuantity : quantity;
	const totalCost =
		record[`${type}ReceivedAverageCost`] !== undefined
			? record[`${type}ReceivedAverageCost`] * qtyToConsider
			: record[`${type}Cost`] !== undefined
			? record[`${type}Cost`]
			: undefined;
	return {
		totalCost,
		unitCost: totalCost !== undefined ? totalCost / qtyToConsider : undefined,
	};
};

export const getPurchaseOrderTotalCost = (purchaseOrder) => {
	const partLineItems = nullSafeGetOrElse('partSupplierPurchaseOrderLineItems', purchaseOrder, []);
	const totalPartCost = partLineItems.reduce(
		(acc, part) => acc + parseFloat(getPOLineItemUnitCostValue(part, 'part')['totalCost'] || 0),
		0
	);

	const equipmentLineItems = nullSafeGetOrElse(
		'equipmentSupplierPurchaseOrderLineItems',
		purchaseOrder,
		[]
	);
	const totalEquipmentCost = equipmentLineItems.reduce(
		(acc, et) => acc + parseFloat(getPOLineItemUnitCostValue(et, 'equipment')['totalCost'] || 0),
		0
	);

	return (
		totalPartCost +
		totalEquipmentCost +
		parseFloat(nullSafeGetOrElse('freightTotalBeforeTax', purchaseOrder, 0)) +
		parseFloat(nullSafeGetOrElse('miscTotalBeforeTax', purchaseOrder, 0)) +
		parseFloat(nullSafeGetOrElse('tax', purchaseOrder, 0))
	);
};

export const EPSL_CONDITION_DP_FILTERS = [
	{
		label: 'Condition',
		fieldName: 'conditions',
		mode: 'multiple',
		type: FILTER_FIELD_TYPE.OW_MULTI_SELECT,
		items: ALL_EPSL_CONDITIONS.map((value) => ({
			label: EPSL_CONDITION_DISPLAY_NAMES[value],
			value,
		})),
		valueType: FILTER_VALUE_TYPE.STRING,
	},
	{
		label: 'Disposition Plan',
		fieldName: 'dispositionPlans',
		mode: 'multiple',
		type: FILTER_FIELD_TYPE.OW_MULTI_SELECT,
		items: ALL_EPSL_DISPOSITION_PLANS.map((value) => ({
			label: EPSL_DISPOSITION_PLAN_DISPLAY_NAMES[value],
			value,
		})),
		valueType: FILTER_VALUE_TYPE.STRING,
	},
];

export const isForwardingAllowedBySettings = (companySettings) => {
	const featureEnabled = posthog.isFeatureEnabled('staging_stock_location_enabled');
	const allowedBySetting = nullSafeGetOrElse(
		'inventoryConfig.allowEquipmentForwarding',
		companySettings,
		false
	);

	return featureEnabled && allowedBySetting;
};

export const isGLCodeAllowedBySettings = (companySettings) =>
	nullSafeGetOrElse('inventoryConfig.enableGLCodeForInventory', companySettings, false);

export const PO_INTEGRATION_STATUS_DISPLAY_NAMES = {
	success: 'Success',
	in_progress: 'In Progress',
	failure: 'Failure',
};
